import type { Product } from '~~/shared/types/store'

export const RECENTLY_VIEWED_PRODUCTS_KEY = 'lavmag:recently-viewed-products'
export const RECENTLY_VIEWED_PRODUCTS_LIMIT = 20

export function createRecentlyViewedProductSnapshot(product: Product): Product {
  return {
    ...product,
    description: '',
    details: [],
    productInfo: [],
    gallery: [],
    // Galeria z kolorami (karta produktu) — w localStorage tylko by puchła.
    galleryItems: undefined,
    colors: [],
    sizes: product.sizes.slice(0, 8),
    measurements: {},
    combinationOptions: [],
    combinations: [],
    sizeVariants: product.sizeVariants.slice(0, 8),
    sizeChart: null,
  }
}

function isProductSnapshot(value: unknown): value is Product {
  if (!value || typeof value !== 'object') return false

  const candidate = value as Partial<Product>
  return typeof candidate.id === 'string'
    && candidate.id.length > 0
    && typeof candidate.slug === 'string'
    && candidate.slug.length > 0
    && typeof candidate.name === 'string'
    && candidate.name.length > 0
}

export function readRecentlyViewedProducts(storage?: Storage): Product[] {
  if (!storage) return []

  try {
    const parsed = JSON.parse(storage.getItem(RECENTLY_VIEWED_PRODUCTS_KEY) || '[]') as unknown
    return Array.isArray(parsed) ? parsed.filter(isProductSnapshot) : []
  }
  catch {
    return []
  }
}

export function writeRecentlyViewedProducts(products: Product[], storage?: Storage) {
  if (!storage) return

  try {
    storage.setItem(RECENTLY_VIEWED_PRODUCTS_KEY, JSON.stringify(products.slice(0, RECENTLY_VIEWED_PRODUCTS_LIMIT)))
  }
  catch {
    // localStorage can be blocked or full; recently viewed should never break product browsing.
  }
}

export function addRecentlyViewedProduct(product: Product, current: Product[], limit = RECENTLY_VIEWED_PRODUCTS_LIMIT): Product[] {
  const snapshot = createRecentlyViewedProductSnapshot(product)
  return [snapshot, ...current.filter(item => item.id !== snapshot.id)].slice(0, limit)
}
